import { cn } from '@/utils/cn';
import { HR_DAY_TYPE_BG } from '@/modules/hr/components/hrCalendarUtils';

const LEGEND_ITEMS: { type: keyof typeof HR_DAY_TYPE_BG; label: string }[] = [
  { type: 'WORKING', label: 'Working day' },
  { type: 'HALF_DAY', label: 'Half day' },
  { type: 'WEEKEND', label: 'Off day' },
  { type: 'HOLIDAY', label: 'Holiday' },
  { type: 'SPECIAL', label: 'Special' },
];

export function HrScheduleCalendarLegend({ className }: { className?: string }) {
  return (
    <div className={cn('flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-slate-600 dark:text-slate-400', className)}>
      {LEGEND_ITEMS.map(({ type, label }) => (
        <span key={type} className="inline-flex items-center gap-1.5">
          <span className={cn('h-3 w-3 rounded border border-slate-200 dark:border-slate-600', HR_DAY_TYPE_BG[type])} />
          {label}
        </span>
      ))}
      <span className="inline-flex items-center gap-1.5">
        <span className="h-3 w-3 rounded border border-primary-300 bg-primary-50 dark:border-primary-700 dark:bg-primary-950/40" />
        Today
      </span>
    </div>
  );
}
